export const FORM_EDITOR_FIELDS = {
	ID: 'id',
	TYPE: 'type',
	LANGUAGE: 'language',
	WIDTH: 'width',
	ALLOW_EDITING_SUBMISSIONS: 'allow_editing_submissions',
	ALLOW_MULTIPLE_SUBMISSIONS: 'allow_multiple_submissions',
	QUIZ_RESULT_PASS_PERCENTAGE: 'quiz_result_pass_percentage',
	QUIZ_RESULT_SHOW_CORRECT_ANSWERS: 'quiz_result_show_correct_answers',
	SCOPE: 'scope',
	SCOPE_ID: 'scope_id',
	SECTIONS: 'sections',
};

export const SECTION_EDITOR_FIELDS = {
	ID: 'id',
	TITLE: 'title',
	DESCRIPTION: 'description',
	CONTINUATION_TYPE: 'continuation_type',
	CONTINUATION_SECTION_ID: 'continuation_section_id',
	WEIGHT: 'weight',
	FIELDS: 'fields',
	ADVANCED_SETTINGS: 'advanced_settings',
	CONTENTS: 'form_section_contents',
	DELETED_CONTENTS: 'deleted_form_section_contents',
};

export const FIELD_EDITOR_FIELDS = {
	ID: 'id',
	TYPE: 'type',
	SUBTYPE: 'subtype',
	TITLE: 'title',
	PLACEHOLDER: 'placeholder',
	HELP: 'help',
	SUBMISSION_FEEDBACK_CORRECT: 'submission_feedback_correct',
	SUBMISSION_FEEDBACK_INCORRECT: 'submission_feedback_incorrect',
	CONDITIONAL: 'conditional',
	FILTER: 'filter',
	PRIVACY: 'privacy',
	REQUIRED: 'required',
	WEIGHT: 'weight',
	FORM_SECTION_ID: 'form_section_id',
	OPTIONS: 'form_field_options',
	CONTENTS: 'form_field_contents',
	DELETED_CONTENTS: 'deleted_form_field_contents',
};

export const OPTION_EDITOR_FIELDS = {
	ID: 'id',
	LABEL: 'label',
	VALUE: 'value',
	IS_CORRECT_ANSWER: 'is_correct_answer',
	CONTINUATION_TYPE: 'continuation_type',
	CONTINUATION_SECTION_ID: 'continuation_section_id',
	WEIGHT: 'weight',
	FORM_FIELD_ID: 'form_field_id',
	CONTENTS: 'form_field_option_contents',
	DELETED_CONTENTS: 'deleted_form_field_option_contents',
};
